__turbopack_context__.v({
  "badge": "BentoEcosystem-module__Qtwvya__badge",
  "bentoCard": "BentoEcosystem-module__Qtwvya__bentoCard",
  "bentoGrid": "BentoEcosystem-module__Qtwvya__bentoGrid",
  "bentoHeader": "BentoEcosystem-module__Qtwvya__bentoHeader",
  "bentoSection": "BentoEcosystem-module__Qtwvya__bentoSection",
  "cardDesc": "BentoEcosystem-module__Qtwvya__cardDesc",
  "cardIcon": "BentoEcosystem-module__Qtwvya__cardIcon",
  "cardTitle": "BentoEcosystem-module__Qtwvya__cardTitle",
  "decoration": "BentoEcosystem-module__Qtwvya__decoration",
  "span2col": "BentoEcosystem-module__Qtwvya__span2col",
  "span2row": "BentoEcosystem-module__Qtwvya__span2row",
  "subtitle": "BentoEcosystem-module__Qtwvya__subtitle",
  "title": "BentoEcosystem-module__Qtwvya__title",
});
